import { CacheServiceModule } from './../cache/cache.service.module';

import { NgModule } from '@angular/core';

@NgModule({
  providers: [CacheServiceModule]
})
export class UZURVServicesModule {}
